// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BasicDialog__wrapper--hsRcB{display:inline-block}.BasicDialog__underline--Q7iL_{border-bottom:1px dashed var(--color-gray900)}`, "",{"version":3,"sources":["webpack://./src/js/components/organisms/BasicDialog.vue"],"names":[],"mappings":"AAEA,6BACE,oBAAA,CAGF,+BACE,6CAAA","sourcesContent":["@use '@/scss/lib/base/variables' as *;\n\n.wrapper {\n  display: inline-block;\n}\n\n.underline {\n  border-bottom: 1px dashed var(--color-gray900);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `BasicDialog__wrapper--hsRcB`,
	"underline": `BasicDialog__underline--Q7iL_`
};
module.exports = ___CSS_LOADER_EXPORT___;
